import { render, staticRenderFns } from "./OneProductDescriptionSection.vue?vue&type=template&id=30586c27&scoped=true&lang=pug&"
import script from "./OneProductDescriptionSection.vue?vue&type=script&lang=ts&"
export * from "./OneProductDescriptionSection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.9.8_vd7qwssw5i3h3fjzjs5bz4d2ha/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30586c27",
  null
  
)

export default component.exports